import Swiper, { Pagination, Navigation } from 'swiper';
import { ProductMedia } from 'Modules/productMedia';
Swiper.use([Pagination, Navigation]);

// @ts-ignore
let module: any = {};

/**
 * Instantiate Vue Application
 */
module.setupAddThis = () => {
    // Set the share link to set up for Add This for the large image
    // let addThisCompactButton = document.querySelectorAll('.addthis_button_compact');
    //
    // addThisCompactButton.forEach((button) => {
    // 	button.setAttribute('href', 'http://api.addthis.com/oexchange/0.8/offer?url=' + fullImageUrl)
    // });
    // $('.addthis_button_compact').attr({
    // 	href:
    // });
};

module.askQuestion = () => {
    function eventFire(el, etype) {
        console.log('got inside eventfire');
        if (el.fireEvent) {
            el.fireEvent('on' + etype);
        } else {
            var evObj = document.createEvent('Events');
            evObj.initEvent(etype, true, false);
            el.dispatchEvent(evObj);
        }
    }

    $('body').on('click', '.bv_war_button', function (event) {
        event.preventDefault();       
        eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#reviews"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
        });
    });

    $('body').on('click', '.bv_aaq_button', function (event) {
        event.preventDefault();       
        eventFire(document.querySelector('.js-tab[data-target="#qas"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#qas"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
        });
    });
    $('body').on('click', '.bv_ratings_summary', function (event) {
        event.preventDefault();      
        eventFire(document.querySelector('.js-tab[data-target="#reviews"]'), 'click');
        let topPosition = document.querySelector('.js-tab[data-target="#reviews"]').getBoundingClientRect().top + document.documentElement.scrollTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth',
        });
    });
};

module.setupSlider = () => {
    const breakpoint = window.matchMedia('(min-width:768px)');
    let fpSlider;
    // let $swiperContainer = $('.js-product-swiper-container');
    let swiperWrapper = document.querySelector('.js-product-detail-wrapper');
    let swiperSlide = document.querySelectorAll('.js-product-detail-slide');

    if (!swiperWrapper) {
        return;
    }

    const breakpointChecker = () => {
        if (breakpoint.matches === true) {
            if (fpSlider !== undefined) {
                // $swiperContainer.removeClass('swiper-container');
                swiperWrapper.classList.remove('swiper-wrapper');
                swiperSlide.forEach((slide) => {
                    slide.classList.remove('swiper-slide');
                });
                fpSlider.destroy(true, true);
            }
            return;
        } else if (breakpoint.matches === false) {
            return enableSlider();
        }
    };

    const enableSlider = () => {
        swiperWrapper.classList.add('swiper-wrapper');
        swiperSlide.forEach((slide) => {
            slide.classList.add('swiper-slide');
        });

        fpSlider = new Swiper('.js-product-detail', {
            loop: false,
            //@ts-ignore
            slidesPerView: '1',
            centeredSlides: true,
            keyboardControl: true,
            grabCursor: true,

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            navigation: {
                nextEl: '.product-detail-next',
                prevEl: '.product-detail-prev',
            },
        });

        fpSlider.init();
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
};

module.setupScrollHelper = () => {
    window.addEventListener('scroll', () => {
        $('.tooltipster-base').hide();
    });
};

module.init = function () {
    module.setupSlider();
    module.setupScrollHelper();
    module.askQuestion();
    ProductMedia.init();
};

if (document.readyState === 'loading') {
    // Loading hasn't finished yet
    document.addEventListener('DOMContentLoaded', module.init);
} else {
    // `DOMContentLoaded` has already fired
    module.init();
}
